import { render } from "./ModalCategoryAdd.vue?vue&type=template&id=325cdfac&scoped=true"
import script from "./ModalCategoryAdd.vue?vue&type=script&lang=js"
export * from "./ModalCategoryAdd.vue?vue&type=script&lang=js"

import "./ModalCategoryAdd.vue?vue&type=style&index=0&id=325cdfac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325cdfac"]])

export default __exports__